import Vuex from 'vuex';
import Vue from 'vue';

Vue.use(Vuex);

export function createStore(baseState) {
	return new Vuex.Store({
		state: baseState,
		getters: {
			searchQuery: state => state.searchQuery,
			searchResult: state => state.searchResult
		},
		mutations: {
			setSearchQuery(state, value) {
				state.searchQuery = value;
			},
			setSearchResult(state, value) {
				state.searchResult = value;
			}
		}
	});
}